function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1338 14.9316H20.0005",
  stroke: "white",
  strokeWidth: 1.26,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 14.9316H4.8",
  stroke: "white",
  strokeWidth: 1.26,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1331 14.5651C11.1331 15.1914 10.9475 15.8035 10.5996 16.3243C10.2517 16.845 9.75718 17.2509 9.17863 17.4906C8.60008 17.7303 7.96344 17.7931 7.3492 17.671C6.73497 17.549 6.17072 17.2475 5.7278 16.8048C5.28488 16.362 4.98317 15.7979 4.86082 15.1838C4.73848 14.5696 4.80099 13.9329 5.04045 13.3542C5.27991 12.7756 5.68557 12.2809 6.20614 11.9328C6.72671 11.5847 7.33882 11.3987 7.96506 11.3984C8.38104 11.3983 8.79297 11.48 9.17733 11.6391C9.56169 11.7981 9.91094 12.0314 10.2051 12.3254C10.4993 12.6195 10.7327 12.9687 10.892 13.3529C11.0512 13.7372 11.1331 14.1491 11.1331 14.5651V14.5651Z",
  stroke: "white",
  strokeWidth: 1.26,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6667 4.79883H1",
  stroke: "white",
  strokeWidth: 1.26,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9993 4.43229C19.9993 3.80604 19.8137 3.19386 19.4658 2.67313C19.1179 2.15241 18.6234 1.74653 18.0448 1.50681C17.4663 1.26709 16.8296 1.2043 16.2154 1.32637C15.6012 1.44844 15.0369 1.7499 14.594 2.19262C14.1511 2.63535 13.8494 3.19946 13.727 3.81364C13.6047 4.42782 13.6672 5.06449 13.9067 5.64315C14.1461 6.22181 14.5518 6.71647 15.0724 7.06459C15.5929 7.41272 16.205 7.59868 16.8313 7.59896C17.6713 7.59896 18.4769 7.26537 19.0709 6.67155C19.665 6.07772 19.999 5.27227 19.9993 4.43229V4.43229Z",
  stroke: "white",
  strokeWidth: 1.26,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSorting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.83159c42.svg";
export { ForwardRef as ReactComponent };